/**
 * Formats a number to Indian currency format (lakhs and crores)
 * @param {number} amount - The amount to format
 * @returns {string} Formatted amount in lakhs or crores
 */
export const formatIndianCurrency = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '₹0';
  }
  
  // Convert to number if it's a string
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  
  if (numAmount >= 10000000) { // 1 crore = 10,000,000
    return `₹${(numAmount / 10000000).toFixed(2)} Cr`;
  } else if (numAmount >= 100000) { // 1 lakh = 100,000
    return `₹${(numAmount / 100000).toFixed(2)} L`;
  } else {
    return `₹${numAmount.toLocaleString('en-IN')}`;
  }
};

/**
 * Formats a number to display in Indian number system (with commas)
 * @param {number} num - The number to format
 * @returns {string} Formatted number with commas
 */
export const formatIndianNumber = (num) => {
  if (num === null || num === undefined || isNaN(num)) {
    return '0';
  }
  
  return num.toLocaleString('en-IN');
};
